import React from 'react';
import agent from '../../../../agent';
import SavedSearchBarChartWidget from './SavedSearchBarChartWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

class SavedSearchBarChartWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      search: {
        rows:[]
      },
      loaded:false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.runSearch(this.props.savedSearchId, this.props.bypassCache, this.props.yAxisColumn, this.props.xAxisColumn);
  }

  runSearch(savedSearchId, bypassCache, yAxisColumn, xAxisColumn) {
    agent.Search.executeBarChartSearch(savedSearchId, bypassCache, yAxisColumn, xAxisColumn).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            'search':res.data,
            'loaded':true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }


  render() {
    if(this.state.loaded) {
      return (
        <SavedSearchBarChartWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} search={this.state.search} />
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }

  }
}

export default SavedSearchBarChartWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchBarChartWidget/SavedSearchBarChartWidgetContainer.js